import axios from 'axios';

// Action types
export const FETCH_YEARBOOK_POSES_REQUEST = 'FETCH_YEARBOOK_POSES_REQUEST';
export const FETCH_YEARBOOK_POSES_SUCCESS = 'FETCH_YEARBOOK_POSES_SUCCESS';
export const FETCH_YEARBOOK_POSES_FAILURE = 'FETCH_YEARBOOK_POSES_FAILURE';
export const SKIP_YEARBOOK_SELECTION = 'SKIP_YEARBOOK_SELECTION';

// Action creators
export const fetchYearbookPosesRequest = () => ({
  type: FETCH_YEARBOOK_POSES_REQUEST,
});

export const fetchYearbookPosesSuccess = (poses) => ({
  type: FETCH_YEARBOOK_POSES_SUCCESS,
  payload: poses,
});

export const fetchYearbookPosesFailure = (error) => ({
  type: FETCH_YEARBOOK_POSES_FAILURE,
  payload: error,
});

// Thunk action to fetch yearbook poses
export const fetchYearbookPoses = (studentId) => {
  return async (dispatch) => {
    try {
      dispatch(fetchYearbookPosesRequest());

      const response = await axios.get(`/api/v2/yearbook/${studentId}`);

      if (response.status >= 200 && response.status < 300) {
        dispatch(fetchYearbookPosesSuccess(response.data));
      } else {
        throw new Error('Failed to fetch yearbook poses');
      }
    } catch (error) {
      dispatch(fetchYearbookPosesFailure(error.message));
    }
  };
};

// Thunk to skip yearbook selection and go to order
export const skipYearbookSelectionAndGoToOrder = (skip) => ({
  type: SKIP_YEARBOOK_SELECTION,
  payload: {
    skipSelectionForSession: skip,
  },
});
